'use strict'; // NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order

require("core-js/modules/es.array.reduce-right.js");

module.exports = function defaultsPure() {
  var sources = Array.prototype.slice.call(arguments);
  return sources.reduceRight(function (acc, source) {
    Object.keys(Object(source)).forEach(function (key) {
      if (source[key] === undefined) {
        return;
      }

      if (acc[key] !== undefined) {
        // remove if already added, so that we can add it in correct order
        delete acc[key];
      }

      acc[key] = source[key];
    });
    return acc;
  }, {});
};